// @flow
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    border: 0; 
    height: 100%;
`;

const Header = styled.div`  
    display: flex;
    justify-content: center;
    
    font-weight: bold;
`;

const Content = styled.div`
    display: flex;
    flex-flow: wrap;
    align-items: center;
    width: 70%;
    margin:auto;
    @media (max-width: 799px) {
        width: 100%;
    }
`;

const Paragraph = styled.div`
    padding: 10px 30px 10px 30px;
`;

export default function() {
return(
    <Container>
        <Header></Header>
        <Content>

            <Paragraph>The page you are looking for has not ben found.</Paragraph>
        </Content>
    </Container>
);
}